import React from 'react';
import PropTypes from 'prop-types';
import { EnergyLabel } from '@sainsburys-tech/bolt-icons';
import { Button } from '@sainsburys-tech/bolt';
import * as Styled from './EnergyLabelBadge.styles';
var validTypes = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

var Wrapper = function Wrapper(_ref) {
  var linkUrl = _ref.linkUrl,
      customLinkName = _ref.customLinkName,
      customLinkAction = _ref.customLinkAction,
      dataTest = _ref.dataTest,
      children = _ref.children;
  var linkName = /*#__PURE__*/React.createElement("span", null, customLinkName || 'Product information sheet');

  if (linkUrl) {
    return /*#__PURE__*/React.createElement(Styled.Wrapper, null, children, customLinkAction ? /*#__PURE__*/React.createElement(Button, {
      type: "button",
      kind: "link",
      onClick: function onClick(event) {
        return customLinkAction(event, linkUrl);
      },
      "data-test": "".concat(dataTest, "-link")
    }, linkName) : /*#__PURE__*/React.createElement("a", {
      href: linkUrl,
      target: "_blank",
      rel: "noreferrer",
      "data-test": "".concat(dataTest, "-link")
    }, linkName));
  }

  return children;
};

var EnergyLabelBadge = function EnergyLabelBadge(_ref2) {
  var type = _ref2.type,
      onClick = _ref2.onClick,
      linkUrl = _ref2.linkUrl,
      customLinkName = _ref2.customLinkName,
      customLinkAction = _ref2.customLinkAction,
      labelWidth = _ref2.labelWidth,
      labelHeight = _ref2.labelHeight,
      dataTest = _ref2['data-test'];
  if (!validTypes.includes(type)) return null;
  return /*#__PURE__*/React.createElement(Wrapper, {
    linkUrl: linkUrl,
    customLinkName: customLinkName,
    customLinkAction: customLinkAction
  }, /*#__PURE__*/React.createElement(Styled.Button, {
    onClick: onClick,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(EnergyLabel, {
    type: type,
    width: labelWidth,
    height: labelHeight
  })));
};

EnergyLabelBadge.defaultProps = {
  onClick:
  /* istanbul ignore next */
  function onClick() {},
  'data-test': 'energy-label-badge'
};
EnergyLabelBadge.propTypes = {
  /**
   * type of Energy label
   */
  type: PropTypes.string.isRequired,

  /**
   * Optional prop to pass through onClick events when button is clicked
   */
  onClick: PropTypes.func,

  /**
   * Optional prop to display the PDF link next to the badge
   */
  linkUrl: PropTypes.string,

  /**
   * Optional prop to display the CUSTOM name for the PDF link next to the badge
   */
  customLinkName: PropTypes.string,

  /**
   * Optional prop to use the link to call a function rather than as an anchor tag
   */
  customLinkAction: PropTypes.func,

  /**
   * Optional prop to change label width
   */
  labelWidth: PropTypes.number,

  /**
   * Optional prop to change label height
   */
  labelHeight: PropTypes.number,

  /**
   * Specify an optional data-test attribute to be added to your Button for e2e testing
   */
  'data-test': PropTypes.string
};
export default EnergyLabelBadge;